import React, { FC, useEffect } from "react";
import Heading from "components/Heading/Heading";
import Glide from "@glidejs/glide";
import { TaxonomyType } from "data/types";
import ncNanoId from "utils/ncNanoId";
import NextPrev from "shared/NextPrev/NextPrev";
import { eventAnalytic } from "hooks/useAnalytics";
import logging from "utils/logging";
import CardBlog from "components/CardBlog";
import { IBlog } from "types/blog";

export interface SectionSliderBlogProps {
  className?: string;
  itemClassName?: string;
  heading?: string;
  subHeading?: string;
  categories?: TaxonomyType[];
  categoryCardType?: "card3" | "card4" | "card5";
  itemPerRow?: 4 | 5;
  sliderStyle?: "style1" | "style2";
  descLink?: string;
  blogs?: Array<IBlog>;
}

const DEMO_CATS: TaxonomyType[] = [
  {
    id: "1",
    href: "#",
    name: "A",
    taxonomy: "category",
    count: 17288,
    thumbnail:
      "https://images.pexels.com/photos/2581922/pexels-photo-2581922.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
  },
  {
    id: "2",
    href: "#",
    name: "Transportasi",
    taxonomy: "category",
    count: 2118,
    thumbnail:
      "https://images.pexels.com/photos/2351649/pexels-photo-2351649.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  },
  {
    id: "3",
    href: "#",
    name: "Pakaian",
    taxonomy: "category",
    count: 36612,
    thumbnail:
      "https://images.pexels.com/photos/962464/pexels-photo-962464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  },
  {
    id: "4",
    href: "#",
    name: "Farm House",
    taxonomy: "category",
    count: 188288,
    thumbnail:
      "https://images.pexels.com/photos/248837/pexels-photo-248837.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  },
  {
    id: "5",
    href: "#",
    name: "Dome House",
    taxonomy: "category",
    count: 188288,
    thumbnail:
      "https://images.pexels.com/photos/3613236/pexels-photo-3613236.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
  },
  {
    id: "6",
    href: "#",
    name: "Dome House",
    taxonomy: "category",
    count: 188288,
    thumbnail:
      "https://images.pexels.com/photos/3613236/pexels-photo-3613236.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
  },
];

const SectionSliderBlog: FC<SectionSliderBlogProps> = ({
  heading = "Kategori",
  subHeading = "Temukan Barang Sesuai Kategori",
  className = "",
  itemClassName = "",
  categories = DEMO_CATS,
  itemPerRow = 5,
  categoryCardType = "card3",
  sliderStyle = "style1",
  descLink = "",
  blogs = [],
}) => {
  const UNIQUE_CLASS = "glide_" + ncNanoId();

  useEffect(() => {
    if (document.querySelector(`.${UNIQUE_CLASS}`)) {
      new Glide(`.${UNIQUE_CLASS}`, {
        perView: itemPerRow,
        gap: 32,
        bound: true,
        breakpoints: {
          1280: {
            perView: itemPerRow,
          },
          1024: {
            gap: 20,
            perView: itemPerRow,
          },
          768: {
            gap: 20,
            perView: itemPerRow - 1,
          },
          640: {
            gap: 20,
            perView: itemPerRow - 2,
          },
          500: {
            gap: 20,
            perView: itemPerRow - 3,
          },
        },
      }).mount();
    }
  }, []);

  const renderCard = (item: IBlog, index: number) => {
    return <CardBlog blog={item}></CardBlog>;
  };

  return (
    <div className={`nc-SectionSliderNewCategories ${className}`}>
      <div className={`${UNIQUE_CLASS} flow-root`}>
        <Heading
          desc={subHeading}
          hasNextPrev={sliderStyle === "style1"}
          isCenter={sliderStyle === "style2"}
          descLink={descLink}
        >
          {heading}
        </Heading>
        <div className="glide__track" data-glide-el="track">
          <ul className="glide__slides">
            {blogs.length > 0 &&
              blogs
                .filter((b) => b.status === "published")
                .reverse()
                .map((item, index) => (
                  <li
                    key={item.href}
                    className={`glide__slide ${itemClassName}`}
                    onClick={() => {
                      logging("", {
                        category: "blog",
                        action: "page",
                        target: item.title || "",
                      });
                      eventAnalytic({
                        category: "Product",
                        action: "Blog Page",
                        label: `${item.title}`,
                      });
                    }}
                  >
                    {renderCard(item, index)}
                  </li>
                ))}
          </ul>
        </div>

        {sliderStyle === "style2" && (
          <NextPrev className="justify-center mt-16" />
        )}
      </div>
    </div>
  );
};

export default SectionSliderBlog;
